/**
 * `numbers` — monday's Condition dropdown, measured on the sandbox board 2026-09-10
 * (`discovery/ui-reference/filters/operators-by-type.json`), in monday's own order.
 *
 * Two measured surprises:
 *  - the ordered comparisons are the **symbols** `=` `≠` `>=` `>` `<=` `<`, not words;
 *  - `is` / `is not` are offered **as well as** `=` / `≠`. They compile to the same
 *    `any_of` / `not_any_of`, but the editor differs: `=` types a number, `is` picks one of
 *    the values already on the board. Hence the explicit ids.
 *  - there is **no** `is between` on a numbers column, which our round-3 list had.
 */
import { IS_EMPTY, IS_NOT_EMPTY, condition } from '../filter-conditions.js';
export const numbersFilterConditions = [
    condition('=', 'any_of', 'number', { id: 'any_of' }),
    condition('≠', 'not_any_of', 'number', { id: 'not_any_of' }),
    condition('>=', 'greater_than_or_equals', 'number'),
    condition('>', 'greater_than', 'number'),
    condition('<=', 'lower_than_or_equal', 'number'),
    condition('<', 'lower_than', 'number'),
    condition('is', 'any_of', 'options', { id: 'any_of:pick' }),
    condition('is not', 'not_any_of', 'options', { id: 'not_any_of:pick' }),
    IS_EMPTY,
    IS_NOT_EMPTY,
];
//# sourceMappingURL=filters.js.map